import React from 'react'

import { Link } from '../index.js'

const textAlignStyle = { verticalAlign: 'baseline' }

const Button = ({ submit, className, small, children, color, matchCase, thin, large, textInline, extraClassName, ...props }) => (
  <button {...{
    type: props.submit ? 'submit' : 'button',
    ...props,
    className: props.className || getButtonClass({ color, matchCase, thin, large, small, extraClassName }),
    style: textInline ? textAlignStyle : undefined
  }}>{children}</button>
)

const getButtonClass = (props) => {
  let style = [`ncss-btn-primary-${props.color || 'dark'}`]

  if (!props.matchCase) style.push('u-uppercase')
  if (props.small) style.push('pt1-sm pb1-sm prl2-sm')
  else if (props.thin) style.push('') // Not yet determined
  else if (props.large) style.push('') // Not yet determined
  else style.push('pt3-sm pr5-sm pb3-sm pl5-sm pt2-lg pb2-lg')

  if (props.extraClassName) style.push(props.extraClassName)

  return style.join(' ')
}

export default Button

const getIcon = icon => icon && icon.indexOf('g72') === 0 ? icon : `fa fa-${icon}`

export const IconButton = ({ icon, color, ...props }) => (
  <button type='button' className='btn icon-solo' {...props}>
    <i className={`${getIcon(icon)} text-color-${color || 'primary-dark'}`} />
  </button>
)

export const LinkButton = ({to, color, icon, label, title, iconOnly, ...props}) => (
  <Link to={to} title={title}>
    {iconOnly
      ? <IconButton color={color} icon={icon} />
      : <Button {...props} color={color}>{label} {icon ? <i className={getIcon(icon)} /> : null }</Button>
    }
  </Link>
)



// WEBPACK FOOTER //
// ./client/src/components/ncss/Button.js